/**
 * get updated City Name
 * @param {*} cityId
 * @param {*} cityName
 * @returns updated cityName
 */
export function getUpdatedCityName(cityId, cityName) {
  // update name for greater-mumbai
  if (cityId === "city-greater-mumbai") {
    return "Mumbai";
  }

  // rest of the cities
  return cityName;
}
